import React, { memo } from "react"
import clsx from "clsx"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { usePlanning } from "./PlanningContext"
import { readableOn } from "../lib/colors"
import { formatHours } from "../lib/hours"

const Chip = ({ assignment, selected }) => {
  const { handlers, projectsById, density, highlightProjectId, canWrite } = usePlanning()
  const project     = projectsById.get(assignment.project_id) || {}
  const color       = project.color || assignment.color || "#64748B"
  const ink         = readableOn(color)
  const highlighted = highlightProjectId && highlightProjectId === assignment.project_id
  const dimmed      = highlightProjectId && !highlighted
  const label       = project.name || project.code
  const timing      = assignment.starts_at && assignment.ends_at ? `${assignment.starts_at} – ${assignment.ends_at}` : formatHours(assignment.hours)
  const tooltip     = [project.title || project.name, assignment.task_title, timing, assignment.note].filter(Boolean).join("\n")
  const draggable   = canWrite && !assignment.pending

  return (
    <div
      draggable={draggable}
      title={tooltip}
      onDragStart={event => handlers.dragAssignment(assignment, event)}
      onDragEnd={handlers.dragEnd}
      onMouseDown={event => event.stopPropagation()}
      onClick={event => { event.stopPropagation(); handlers.clickAssignment(assignment, event) }}
      style={{ backgroundColor: color, color: ink }}
      className={clsx(
        "pp-chip group/chip relative rounded-[5px] px-1.5 select-none shadow-[0_1px_0_rgba(15,23,42,0.12)] transition-[transform,filter,opacity] duration-150",
        draggable ? "cursor-grab active:cursor-grabbing hover:-translate-y-px hover:brightness-110" : "cursor-pointer",
        density === "compact" ? "py-0.5" : "py-1",
        assignment.pending && "pp-pending",
        highlighted && "ring-2 ring-offset-1 ring-slate-900",
        selected && "ring-2 ring-brand-500 ring-offset-1",
        dimmed && "opacity-30",
      )}
    >
      {density !== "compact" && (
        <div className="flex items-center gap-1 min-w-0 text-[10px] font-medium tabular-nums leading-[1.25] opacity-90">
          <span className="truncate">{timing}</span>
          {assignment.note && <FontAwesomeIcon icon="note-sticky" className="ml-auto shrink-0 text-[9px]" />}
        </div>
      )}
      <div className={clsx("truncate font-semibold leading-[1.25]", density === "compact" ? "text-[10.5px]" : "text-[11.5px]")}>
        {label}
      </div>

    </div>
  )
}

export default memo(Chip)
